import * as React from 'react';
import { FC } from 'react';

import { Switch } from '@rmwc/switch';
import '@rmwc/switch/styles';

import { ClientSettings, useClientSetting, useUpdateClientSettings } from '../client_settings';

interface ClientSettingSwitchProps {
  // TODO type magic
  setting: 'showMap' | 'showCustomerNames';
  label: string;
}

export const ClientSettingSwitch: FC<ClientSettingSwitchProps> = ({ setting, label }) => {
  const value = useClientSetting(setting);
  const update = useUpdateClientSettings();

  const toggle = () => {
    if(!update) {
      alert("Internal error");
      return;
    }

    const obj: Partial<ClientSettings> = {};
    obj[setting] = !value;
    update(obj);
  }

  return (
    <Switch checked={value} onClick={toggle} label={label} />
  );
};

